<template>
  <div class="l-page l-page--analysis">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" :additional-classes="['p-breadcrumb--analysis']" />
        <!-- /パンくずリスト -->
        <date-range-picker
          ref="refCalendarModal"
          :initial-start-date="calendarStartDate"
          :initial-end-date="calendarEndDate"
          :on-date-range-changed="onDateRangeChanged"
          cancel-button-label="キャンセル"
          enter-button-label="決定"
        />
      </div>
      <div class="l-main-content">
        <div class="p-analysis-demogra">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">年齢・性別での傾向</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ displayStartDate }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ displayEndDate }}</li>
              </ul>
            </div>
          </h2>
          <analysis-tab
            :current="tab.current"
            :on-select="onTabClick"
          />
          <h3 class="c-title">
            <div class="c-title__text u-fs--l">全ての配信結果に対しての割合</div>
          </h3>
          <div
            class="p-analysis-demogra__graph"
            :class="[{'is-loading': isLoadingHeatmap || isLoadingRatio || isLoadingHeatmap}, {'is-empty': isEmptyHeatmap || isEmptyRatio || isEmptyStackChart}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="p-analysis-demogra__graph-ratio">
              <div class="c-graph-ratio-gender">
                <div class="c-graph-ratio-gender__label">性別（%）</div>
                <div class="c-graph-ratio-gender-bar">
                  <div class="c-graph-ratio-gender-bar-inner">
                    <div class="c-graph-ratio-gender-bar__item c-graph-ratio-gender-bar__item--left">
                    </div>
                    <div class="c-graph-ratio-gender-bar__item c-graph-ratio-gender-bar__item--right">
                    </div>
                  </div>
                </div>
                <div class="c-graph-ratio-gender-value">
                  <div class="c-graph-ratio-gender-value__item c-graph-ratio-gender-value__item--left">
                  </div>
                  <div class="c-graph-ratio-gender-value__item c-graph-ratio-gender-value__item--right">
                  </div>
                </div>
              </div>
              <div class="c-graph-heatmap-age">
                <div class="c-graph-heatmap-age-bar__label">年齢（歳）</div>
                <ul class="c-graph-heatmap-age-bar">
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="_19"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="20_29"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="30_34"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="35_39"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="40_44"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="45_49"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="50_59"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="60_"></li>
                </ul>
                <ul class="c-graph-heatmap-age-bar-label-x">
                  <div class="c-graph-heatmap-age-bar-label-x__item">それ以下</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">20</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">30</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">35</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">40</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">45</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">50</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">それ以上</div>
                </ul>
              </div>

            </div>
            <div class="p-analysis-demogra__graph-bar">
              <svg class="c-graph-stack-chart">
                <!-- クリッピングマスク: 背景フレームと同サイズ -->
                <defs>
                  <clipPath id="clipPath">
                    <rect
                      x="15"
                      y="20"
                      height="200"
                      width="375"
                    />
                  </clipPath>
                </defs>

                <!-- 背景フレーム -->
                <g class="c-graph-stack-chart-frame" clip-path="url(#clipPathStackChart)">
                  <rect
                    class="c-graph-stack-chart-frame__rect"
                    x="15"
                    y="20"
                    height="200"
                    width="375"
                  />
                  <line
                    class="c-graph-stack-chart-frame__line"
                    x1="15"
                    x2="390"
                    y1="220"
                    y2="220"
                  />
                </g>

                <!-- X.Y軸罫線 -->
                <g class="c-graph-stack-chart-bg" clip-path="url(#clipPathStackChart)">
                  <g class="c-graph-stack-chart-bg__x" />
                  <g class="c-graph-stack-chart-bg__y" />
                </g>

                <!-- X.Y軸メモリ -->
                <g class="c-graph-stack-chart-axis">
                  <g class="c-graph-stack-chart-axis__x" />
                  <g class="c-graph-stack-chart-axis__y--left" />
                </g>

                <!-- 積み上げグラフタイトル -->
                <g class="c-graph-stack-chart-label">
                  <text
                    class="c-graph-stack-chart-label__text"
                    opacity="1"
                    y="0"
                    x="-25"
                    text-anchor="start"
                  >年齢別での比較</text>
                </g>

                <!-- 積み上げグラフバー用ラベル -->
                <g class="c-graph-stack-chart-bar-label" />

                <!-- 積み上げグラフバー -->
                <g class="c-graph-stack-chart-bar" clip-path="url(#clipPathStackChart)" />

                <!-- 積み上げグラフバー区切り線 -->
                <g class="c-graph-stack-chart-bar-line" clip-path="url(#clipPathStackChart)" />
              </svg>

              <div class="c-tooltip c-tooltip--graph-line">
                <div class="c-tooltip__title">-</div>
                <ul class="c-tooltip-list">
                  <li class="c-tooltip-list__item c-tooltip-list__item--optin">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--delivery">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--impression">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--click">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--ctr is-active">-</li>
                </ul>
              </div>

            </div>
          </div>
          <h3 class="c-title c-title--download">
            <div class="c-title__text u-fs--l">全ての配信結果での合計数</div>
            <div class="c-text"><a href="#">CSVデータ ダウンロード</a></div>
          </h3>
          <div
            class="p-analysis-demogra__data"
            :class="[{'is-loading': isLoadingDataTable}, {'is-empty': isEmptyDataTable}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--stack-chart-age">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w130 is-sortable">
                    <span class="c-table__text">性別</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'genderId' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'genderId' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'genderId') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">年齢</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'ageId' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'ageId' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'ageId') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">配信対象数</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'delivery' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'delivery' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'delivery') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">インプレッション</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'impression' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'impression' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'impression') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'click' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'click' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'click') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">クリック率(%)</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'ctr' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'ctr' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'ctr') }"
                    ></span>
                  </th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    breadcrumbData: Array,
    displayPeriod: Object,
  },

  data () {
    return {
      errorMessage: '',
      heatmapModule: null,
      ratioModule: null,
      stackChartModule: null,
      isEmptyHeatmap: false,
      isEmptyRatio: false,
      isEmptyStackChart: false,
      isEmptyDataTable: false,
      isError: false,
      isLoadingHeatmap: true,
      isLoadingRatio: true,
      isLoadingStackChart: true,
      isLoadingDataTable: true,
      isInitialized: false,
      range: {
        from: this.displayPeriod && this.displayPeriod.from && dayjs(this.displayPeriod.from).isValid()
          ? dayjs(this.displayPeriod.from).toDate()
          : dayjs().add(-30, 'days').toDate(),
        to: this.displayPeriod && this.displayPeriod.to && dayjs(this.displayPeriod.to).isValid()
          ? dayjs(this.displayPeriod.to).toDate()
          : dayjs().toDate(),
      },
      tab: {
        current: 'delivery',
      },
      sort: {
        key: 'delivery',
        type: 'desc'
      }
    }
  },

  computed: {
    calendarStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY-MM-DD')
        : dayjs().add(-30, 'days').format('YYYY-MM-DD')
    },
    calendarEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD')
    },
    displayStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY/MM/DD')
        : '-'
    },
    displayEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY/MM/DD')
        : '-'
    }
  },

  mounted: function() {
    // グラフモジュールの読み込み
    import('../../funcs/components/graph/graph-heatmap-delivery-age').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.heatmapModule = module;
    });

    // グラフモジュールの読み込み
    import('../../funcs/components/graph/graph-ratio-delivery-gender').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.ratioModule = module;
    });

    // グラフモジュールの読み込み
    import('../../funcs/components/graph/graph-stack-chart-delivery-age').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.stackChartModule = module;
    });

    let importCounter = 1;
    const importTimer = setInterval(() => {
      // 読み込み待機回数のカウントアップ (* 0.5秒毎
      importCounter++;

      // 30秒経過してもモジュールが読み込み終わらない場合はエラーを表示して終了
      if (importCounter > 60) {
        this.isError = true;
        this.errorMessage = '予期せぬエラーが発生しました';
        clearInterval(importTimer);
        return;
      }

      // 何れかのモジュールの読み込みが完了していない場合は処理スキップ
      if (this.heatmapModule == null || this.ratioModule == null || this.stackChartModule == null) return;

      // モジュール読み込みが全て完了した場合はタイマーを停止
      clearInterval(importTimer);

      // モジュール読み込み後に初期化処理実行
      this.updateDataset();
    }, 500);

  },

  methods: {
    updateDataset: function() {
      // グラフモジュールの読み込みが完了していない場合は処理終了
      if (this.heatmapModule == null || this.ratioModule == null || this.stackChartModule == null) return;

      // ローダー表示設定
      this.isLoadingRatio = true;
      this.isLoadingHeatmap = true;
      this.isLoadingStackChart = true;
      this.isLoadingDataTable = true;

      // 送信パラメーター作成
      const params = {
        from: dayjs(this.range.from).format('YYYY-MM-DD'),
        to: dayjs(this.range.to).format('YYYY-MM-DD'),
      }

      // ヒートマップ用データの取得処理実行
      axios.get(`/api/analysis/summary-demogra/${this.tab.current}`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.items) throw new Error('Invalid response data.');

        // 性別比率、年齢比率、年齢別スタックチャートデータの初期化処理実行
        this.ratioModule.ratio(res.data, this.tab.current);
        this.heatmapModule.heatmap(res.data, this.tab.current);
        this.stackChartModule.graph(res.data, this.tab.current);

        // データリスト更新
        this.stackChartModule.dataList({
          key: this.sort.key,
          order: this.sort.type,
        });

        // waitTime設定 ( スタックチャートは初回描画に時間がかかるので、初回のみ1秒待機
        const wait = (this.isInitialized) ? 300 : 1000;
        this.isInitialized = true;

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingRatio = false;
          this.isLoadingHeatmap = false;
          this.isLoadingStackChart = false;
          this.isLoadingDataTable = false;
        }, wait)
      })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '配信結果データの取得に失敗しました';

          // ローダー非表示設定
          setTimeout(() => {
            this.isLoadingRatio = false;
            this.isLoadingHeatmap = false;
            this.isLoadingStackChart = false;
            this.isLoadingDataTable = false;
          }, 300)
        });
    },

    onTabClick: function(selected) {
      // 選択値が設定されていない場合は処理終了
      if (!selected) return;

      // 選択値が現在の選択値値と同じ場合は処理終了
      if (selected == this.tab.current) return

      // 選択値を現在のタブ名に設定
      this.tab.current = selected;

      // データ更新
      this.updateDataset();
    },

    onSortClick: function(e, key) {
      // ローダー表示設定
      this.isLoadingDataTable = true;

      // クリックしたソートボタンの状態で昇順・皇潤を判定 && ソートボタンの表示を切り替え
      if (e.target.classList.contains('c-btn--sort-desc')) {
        this.sort.key = key;
        this.sort.type = 'asc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-asc');
      } else {
        this.sort.key = key;
        this.sort.type = 'desc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-desc');
      }

      this.stackChartModule.dataList({
        key: this.sort.key,
        order: this.sort.type,
      });

      // ローダー非表示設定
      setTimeout(() => {
        this.isLoadingDataTable = false;
      }, 300)
    },

    onDateRangeChanged: function(range){
      // 取得データ期間の更新
      this.range.from = range.start;
      this.range.to= range.end;

      // データ更新
      this.updateDataset();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>
